import { useRef, useEffect } from 'react';
import dropdownStyles from './Dropdown.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import classNames from 'clsx';

function SingleItem(props) {
  const {
    activeValue,
    option,
    id,
    value,
    onSelect
  } = props;
  const active = option.value === activeValue;
  const selected = option.value === value;
  const className = classNames(dropdownStyles['option'], dropdownStyles['single-option-contents'], option.disabled && dropdownStyles['disabled'], active && dropdownStyles['active'], selected && dropdownStyles['selected']);
  const ref = useRef(null);
  useEffect(() => {
    if (active) {
      ref.current?.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [active]);
  function handleClick() {
    if (!option.disabled) {
      onSelect(option.value);
    }
  }
  return /*#__PURE__*/jsx("div", {
    "aria-selected": selected,
    className: className,
    id: id,
    ref: ref,
    role: "option",
    onClick: handleClick,
    children: option.label
  }, option.value);
}

export { SingleItem };
